// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"cd4f8282","232":"8d7fe59e","237":"072bec48","364":"c6fc5b4d","526":"d3563578","973":"a2a58186"}[chunkId] + ".chunk.js";
};